// Contact information configuration
// Update these values with your actual contact information

export const contactConfig = {
    // WhatsApp number with country code
    // Format: +[country code][number without leading 0]
    whatsapp: '+905412171161', // 0541 217 11 61
    
    // Phone numbers
    phone: {
        primary: '0(212) 588 40 90',
        secondary: '0(541) 217 11 61'
    },
    
    // Email addresses
    email: {
        primary: 'info@hasekisultankizyurdu.com',
        support: 'info@hasekisultankizyurdu.com'
    },
    
    // Address
    address: {
        line1: 'Haseki Sultan Mahallesi',
        line2: 'Cevdetpaşa Caddesi No:124 Fındıkzade, Fatih, İstanbul',
        full: 'Haseki Sultan Mahallesi Cevdetpaşa Caddesi No:124 Fındıkzade, Fatih, İstanbul'
    },
    
    // Social media links
    social: {
        instagram: 'https://www.instagram.com/hasekisultankizyurdu/'
    }
}

// Helper function to generate WhatsApp link
export const getWhatsAppLink = (message = '') => {
    const encodedMessage = encodeURIComponent(message)
    const phoneNumber = contactConfig.whatsapp.replace(/[^0-9+]/g, '')
    return `https://wa.me/${phoneNumber}${message ? `?text=${encodedMessage}` : ''}`
}

